import { ObjectDb } from './object.db';
import { Injectable } from '@angular/core';
import {
    ServiceMedicalProcedureObject,
} from '@libs/types/src/services/object-type/service/service-medical-procedure.object';

@Injectable({ providedIn: 'root' })
export class ServiceMedicalProcedureDb extends ObjectDb<ServiceMedicalProcedureObject> {

    public tableName = 'serviceMedicalProcedure';

    protected override columnMap = {};
    protected override indices = ['id', 'serviceId'];
    protected override checkField = 'updatedAt';

    protected gqlMethod = 'getServiceMedicalProcedures';

    protected override refreshOnUserChange = false;

    protected syncFragment = `
        id
        serviceId
        code
        active
        customCode
        customName
        color
        textTemplate
        updatedAt
        procedure {
            code
            description
            duration
        }
    `;

}
